import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {CommissionRedirection} from '../../../../shared/interface/commission-redirection';
import {CommissionRedirectionService} from '../../../../shared/services/commission-redirection.service';

@Component({
  selector: 'app-redirection-details',
  templateUrl: './redirection-details.component.html',
  styleUrls: ['./redirection-details.component.scss']
})
export class RedirectionDetailsComponent implements OnInit, OnDestroy {
  commissionRedirectionId?: string = null;
  commissionRedirection: ReplaySubject<CommissionRedirection> = new ReplaySubject(1);
  commissionRedirectionObject?: CommissionRedirection = null;
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commissionRedirectionService: CommissionRedirectionService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.commissionRedirectionId = params.id;
        this.loadCommissionRedirection();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadCommissionRedirection(): void {
    this.commissionRedirectionService.get(this.commissionRedirectionId).subscribe((commissionRedirection: CommissionRedirection) => {
      this.commissionRedirection.next(commissionRedirection);
      this.commissionRedirectionObject = commissionRedirection;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych przepięcia', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/przepiecia-polis']);
    });
  }

}
